<div *ngIf="!isCatalogView; else catalogView" class="process-item" [ngClass]="getClassName()" [class.process-item-btn]="hasViewLink">
    <div class="process-item__row" [ngClass]="{'process-item__row_v2': totalColumns.length > 2}" (click)="getLinkView()" *ngFor="let i of totalColumns">
      <p *ngIf="getItemValue(i+1); else noContent">{{ getItemValue(i+1) }}</p>
      <ng-template *ngIf="i == 0" #noContent><p>Sem Título</p></ng-template>
    </div>
    <div class="process-item__row" [ngClass]="{'process-item__row_v2': totalColumns.length > 2}" (click)="getLinkView()">
      <div class="status badge badge-pill">
        {{ getStatus() }}
      </div>
    </div>
    <div class="process-item__row" [ngClass]="{'process-item__row_v2': totalColumns.length > 2}">
      <div class="btn-group dropleft">
        <button *ngIf="hasActions" type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="dots-icon">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </button>

        <div *ngIf="getStepOptionByKey('tooltip')"
            class=".popover-info-summary-component-list"
            [popover]="getStepOptionByKey('tooltip')"
            placement="right"
            container="body"
            triggers="mouseenter:mouseleave">
            <i class="fa fa-question-circle"
            ></i>
        </div>

        <div class="dropdown-menu">
            <ul>
              <li *ngFor="let link of getLinks()">
                <a href="javascript:;" (click)="chooseMode(link)" aria-expanded="true">
                    <i class="fa" [ngClass]="getOptionClassName(link)"></i>
                </a>
              </li>
            </ul>
        </div>
      </div>
    </div>
</div>

<ng-template #catalogView>
  <div class="catalog-card process-item" [ngClass]="getClassName()" (click)="onCardClick($event)">
    <div class="catalog-card__image">
      <ng-container *ngIf="getCatalogImageUrl(); else imagePlaceholder">
        <img [src]="getCatalogImageUrl()" [alt]="getItemValue(1) || 'Item'" />
      </ng-container>
      <ng-template #imagePlaceholder>
        <i class="fa fa-image catalog-card__image-placeholder" aria-hidden="true"></i>
      </ng-template>
    </div>
    <div class="catalog-card__body">
      <h4 class="catalog-card__title">{{ getItemValue(1) || 'Sem Título' }}</h4>
      <p class="catalog-card__subtitle" *ngIf="getItemValue(2)">{{ getItemValue(2) }}</p>
      <div class="catalog-card__price" *ngIf="getCatalogPrice()">{{ getCatalogPrice() }}</div>
      <div class="catalog-card__tags" *ngIf="getTagAttributes()?.length">
        <span class="badge badge-pill" *ngFor="let tag of getTagAttributes()" [ngClass]="getOptionClassName(tag) || 'badge-primary'">{{ tag.value }}</span>
      </div>
    </div>
    <div class="catalog-card__actions">
      <div class="btn-group dropleft">
        <button *ngIf="hasActions" type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="dots-icon">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
          </div>
        </button>
        <div class="dropdown-menu">
          <ul>
            <li *ngFor="let link of getLinks()">
              <a href="javascript:;" (click)="chooseMode(link)" aria-expanded="true">
                <i class="fa" [ngClass]="getOptionClassName(link)"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
